var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 21.1889L12.7209 20.3763C13.5392 19.4391 14.2752 18.55 14.93 17.7043L15.4706 16.9911C17.7277 13.95 18.8569 11.5363 18.8569 9.75228C18.8569 5.94428 15.7871 2.85742 11.9997 2.85742C8.21229 2.85742 5.14258 5.94428 5.14258 9.75228C5.14258 11.5363 6.27172 13.95 8.52886 16.9911L9.06944 17.7043C10.0037 18.9013 10.9811 20.0628 11.9997 21.1889Z",
    stroke: "#79AC78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 12.5717C13.5777 12.5717 14.8569 11.2925 14.8569 9.71456C14.8569 8.13661 13.5777 6.85742 11.9997 6.85742C10.4218 6.85742 9.14258 8.13661 9.14258 9.71456C9.14258 11.2925 10.4218 12.5717 11.9997 12.5717Z",
    stroke: "#79AC78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.30a7dc42400b81977c8373a6e671c767.svg";
export { ForwardRef as ReactComponent };